// extracted by mini-css-extract-plugin
module.exports = {"price-guide-link-container":"PriceGuideLinks_price-guide-link-container__3rXKx","price-guide-links":"PriceGuideLinks_price-guide-links__s9ZNp"};